let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("3VzRy"), load("2sCab")]).then(() => parcelRequire('3GuAz'));